import { Fragment } from 'react';

import useClubMemberRequirements from './UseClubMemberRequirements';

import ClubMemberRequirementsGrid from './ClubMemberRequirementsGrid';

import Headings from '@usas/ui-web/components/headings/Headings';
import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';

import { DEFAULT_ID } from '@usas/ui-web/utils/Constants';

const ClubMemberRequirements = () => {
  const {
    isLoading,
    orgUnitId,
    reportRouteName,
    state,
    gridState,
    onReloadPageClicked,
    onBackToClubInfoClicked,
    onOrgRoleFilterChanged,
  } = useClubMemberRequirements();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Member Requirements</Headings.H3>
        </div>
      </div>
      <div className="row usas-extra-bottom-margin">
        <div className="col-xs-12 col-sm-6 col-md-4">
          <Dropdown
            label="Filter By Registration Role"
            name="orgRoleId"
            value={gridState.orgRoleId}
            options={gridState.orgRoleOptions}
            isLoading={gridState.orgRoleOptions.length === 0}
            onChange={(value, valueLabel, e) => { e?.target?.value && onOrgRoleFilterChanged(value); }} />
        </div>
      </div>
      {gridState.orgRoleId !== DEFAULT_ID &&
        <div className="row usas-extra-top-margin">
          <div className="col-xs-12 col-md-4">
            <SecondaryButton type="button" onClick={() => onOrgRoleFilterChanged(DEFAULT_ID)}>Clear Filters</SecondaryButton>
          </div>
        </div>
      }
      <div className='row'>
        <div className="col-xs-12 usas-extra-bottom-margin">
          <ClubMemberRequirementsGrid
            data={gridState.gridData}
            dataTotal={gridState.totalClubMembers}
            isLoading={isLoading}
            reportRouteName={reportRouteName}
            orgUnitId={orgUnitId} />
        </div>
      </div>
      {state.pageErrorMessage !== '' &&
        <PopUpModal
          widthPct={90}
          maxWidth={720}
          title={'Member Requirements Error'}
          displayPopUp={true}
          onModalCanceled={onReloadPageClicked}>
          <div className="row">
            <div className="col-xs-12">
              <p>{state.pageErrorMessage}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 usas-extra-top-margin">
              <PrimaryButton type="button" onClick={onReloadPageClicked}>Reload Member Requirements</PrimaryButton>&nbsp;
              <SecondaryButton type="button" onClick={onBackToClubInfoClicked}>Go Back To Club Info</SecondaryButton>
            </div>
          </div>
        </PopUpModal>
      }
    </Fragment>
  );
};

export default ClubMemberRequirements;